import { render, staticRenderFns } from "./UserInfoItem.vue?vue&type=template&id=95bae4b2&scoped=true&"
import script from "./UserInfoItem.vue?vue&type=script&lang=js&"
export * from "./UserInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoItem.vue?vue&type=style&index=0&id=95bae4b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bae4b2",
  null
  
)

export default component.exports